/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileContract} from '@fortawesome/pro-duotone-svg-icons';

const ReportsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileContract} {...props} />
);

export default ReportsIcon;
